const STATUS_LABEL = {
  1: 'Ativo',
  2: 'Inativo'
};

export const mapDestaqueItem = (item) => ({
  id: item['DestaqueId'],
  cod: item['DestaqueId'],
  descricao: item['Descricao'] || '',
  url: item['Url'] || '',
  imagemUrl: item['ImagemUrl'] || '',
  deepLinking: Boolean(item['DeepLinking']),
  aplicativoId: item['AplicativoId'],
  statusId: item['StatusId'],
  status: STATUS_LABEL[item['StatusId']] || String(item['StatusId'] ?? ''),
  tipoPlataformaId: item['TipoPlataformaId'],
  tipoModuloId: item['TipoModuloId'],
  tipoAcaoDestaqueId: item['TipoAcaoDestaqueId'],
  ordem: item['Ordem'],
  estabelecimentoId: item['EstabelecimentoId']
});

export const mapFetchDestaquesResponse = (response) => {
  const list = (response && response['Destaques']) || [];
  return list.map(mapDestaqueItem);
};

export const mapFetchDestaqueIdResponse = (response) => {
  if (!response) return null;
  const list = response['Destaques'];
  if (Array.isArray(list) && list.length > 0) {
    return mapDestaqueItem(list[0]);
  }
  if (response['DestaqueId'] || response['ImagemUrl']) {
    return mapDestaqueItem(response);
  }
  return null;
};

export const mapDestaqueFormToApi = (data) => {
  const formData = new FormData();
  const request = {
    Descricao: data.descricao,
    Url: data.url || null,
    DeepLinking: Boolean(data.deepLinking),
    Ordem: data.ordem != null && data.ordem !== '' ? Number(data.ordem) : 1,
    TipoPlataformaId: data.tipoPlataformaId != null ? Number(data.tipoPlataformaId) : null,
    TipoModuloId: data.tipoModuloId != null ? Number(data.tipoModuloId) : null,
    TipoAcaoDestaqueId:
      data.tipoAcaoDestaqueId != null && data.tipoAcaoDestaqueId !== ''
        ? Number(data.tipoAcaoDestaqueId)
        : null,
    EstabelecimentoId:
      data.estabelecimentoId != null && data.estabelecimentoId !== ''
        ? Number(data.estabelecimentoId)
        : null,
    AplicativoId: data.aplicativoId != null ? Number(data.aplicativoId) : null
  };

  formData.set('request', JSON.stringify(request));
  if (data.image) {
    formData.append('image', data.image);
  }
  return formData;
};
